module.exports = __webpack_public_path__ + "img/1-17.f833e7a3.png";